import { useState } from "react";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ReadMoreIcon from '@mui/icons-material/ReadMore';



export default function DiaGetClockData() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="History" placement="left">
            <IconButton onClick={handleOpen} sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                <ReadMoreIcon sx={{color: 'common.blacl', '&:hover': { transform: 'scale(1.1)'}, }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialog open={open} onClose={handleClose}

          title="Biological clocks - how is it calculated?"
         
          content = {""}

        />
        
</>
)}